import React from "react";
import { CentsField, Form } from "@culturehq/components";
import { Trans } from "app/utils";
import { EngagementCost, EngagementTabProps } from "./types";
import socialOptions from "./socialOptions";
import displayTooltip from "./displayTooltip";

const EngagementTab: React.FC<EngagementTabProps> = ({
  socialMediaTypes,
  costs,
  setCost
}) => {
  const handleChange = (
    socialType: string,
    costType: string,
    exists: boolean
  ) => (value: any) => {
    const costTypeProp = `${costType}Cost`;

    const update = (prev: EngagementCost[]) => prev.map(
      (ec: any) => (
        ec.socialMediaType === socialType
          ? { ...ec, [costTypeProp]: value }
          : ec
      )
    );
    const insert = (prev: Partial<EngagementCost>[]) => [...prev, {
      socialMediaType: socialType,
      [costTypeProp]: value
    }];

    setCost(prev => (exists ? update(prev) : insert(prev)));
  };

  return (
    <div>
      <h4>Engagement cost</h4>
      <Form onSubmit={() => {}}>
        {socialOptions.map(op => {
          const cost = costs.find(cs => cs.socialMediaType === op.value);
          const exists = !!cost;
          const disabled = !socialMediaTypes?.find(smt => smt.name === op.label);

          return (
            <div>
              <Trans>{op.label}</Trans>
              <div className="row emvTooltip">
                <div className="col-sm-6 col-md-4 p3">
                  { displayTooltip(disabled,
                    <CentsField
                      name={`${op.value}-likes`}
                      disabled={disabled}
                      value={cost?.likesCost}
                      onChange={handleChange(op.value, "likes", exists)}
                    >
                      Likes
                    </CentsField>
                  )}

                </div>
                <div className="col-sm-6 col-md-4 p3">
                  { displayTooltip(disabled,
                    <CentsField
                      name={`${op.value}-comments`}
                      disabled={disabled}
                      value={cost?.commentsCost}
                      onChange={handleChange(op.value, "comments", exists)}
                    >
                      Comments
                    </CentsField>
                  )}
                </div>
                <div className="col-sm-6 col-md-4 p3">
                  { displayTooltip(disabled,
                    <CentsField
                      name={`${op.value}-shares`}
                      disabled={disabled}
                      value={cost?.sharesCost}
                      onChange={handleChange(op.value, "shares", exists)}
                    >
                      Shares
                    </CentsField>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </Form>
    </div>
  );
};

export default EngagementTab;
